module.exports = {
          srcSet: __webpack_public_path__ + "images/1856-58b4cb21cd2618ac9371c7f5b268c257-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1856-547caac2a5ee90db525ff26e54628472-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1856-58b4cb21cd2618ac9371c7f5b268c257-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1856-547caac2a5ee90db525ff26e54628472-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1856-58b4cb21cd2618ac9371c7f5b268c257-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1856-58b4cb21cd2618ac9371c7f5b268c257-320.jpg"},
          
          width: 320,
          height: 251
        }